import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Nav from './Nav';
import Footer from '../Footer/Footer';
import "./Layout.scss";
import getUnviewedNotification from '../Notifications/SubComponents/UnviewedNotification';
import useUserInfo from '../../hooks/useUserInfo';
import { ADVISOR_OBJECT_KEY, getSessionStorageItem, setSessionStorageItem } from '../../sessionStorage';
export default function Layout(props) {

  const { logoURL, iscName, navLinks, setActiveNavLink } = props;
  const { setNotificationCount } = useUserInfo();
  const [expanded, setExpanded] = useState(true);
  const location = useLocation();
  const IsResourceCenterPage = location.pathname.toLocaleLowerCase() === '/resourcecenter';

  useEffect(() => {
    getUnviewedNotification().then((count) => {
      let advisorObj = getSessionStorageItem(ADVISOR_OBJECT_KEY);
      advisorObj.unviewedNotificationCount = count;
      setSessionStorageItem(ADVISOR_OBJECT_KEY, advisorObj);
      setNotificationCount(count)
    }
    )
  }, [navLinks])

  return (
    <div>
      <Nav
        logoURL={logoURL}
        expanded={expanded}
      />
      <Sidebar navLinks={navLinks} setActiveNavLink={setActiveNavLink} expanded={expanded} onClick={() => setExpanded(!expanded)} />
      <div id={IsResourceCenterPage ? 'advisor-resource-container' : 'advisor-dashboard-container'} className={expanded ? "sidebar-open" : "sidebar-close advisor-close"}>
        {props.children}
      </div>
      <Footer expanded={expanded} />
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/Layout/Layout.js